import TariffChoiceList from './TariffChoiceList';

export default TariffChoiceList;
